import WhyOneMindFrame from "@/components/whyOneMind";
import { REASON_COMP } from "./constants";

const ReasonComp = () => {
  const { image, title, points } = REASON_COMP;
  return <WhyOneMindFrame title={title} image={image} points={points} />;
};

export default ReasonComp;
